import { useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { useBatchEdit } from '../shared/context/BatchEditContext';

/**
 * Key del editor de informes: navegar entre lienzo en blanco, borrador, informe
 * guardado o lote monta siempre una instancia limpia. Así "enviar informe" puede
 * reutilizar la misma ruta para abrir un informe nuevo sin arrastrar el anterior.
 * En lote, cada estudio es una instancia: pasar al siguiente no hereda el borrador,
 * la sala ni el contenido del anterior (feature-106).
 */
export function useReportEditorKey(): string {
  const { draftId, savedReportId, batchId } = useParams();
  const { state, key: historyKey } = useLocation();
  const { currentIndex } = useBatchEdit();
  // El lienzo en blanco se identifica por la entrada del historial: dos
  // aperturas seguidas comparten ruta (/reports/v2/edit) y con una key fija
  // el editor no se remontaria al enviar un informe (se quedaria el anterior).
  const routeKey = draftId || savedReportId || (batchId && `${batchId}#${currentIndex}`) || `blank-${historyKey}`;
  // Excepcion: el borrador lo crea la propia pagina con el primer contenido
  // guardable y luego se autorredirige a /draft/:id. Es la misma sesion de
  // edicion, asi que se conserva la key: remontar ahi destruiria el editor con
  // lo que el usuario esta escribiendo.
  const isRedirect = !!(state as { blankDraftRedirect?: boolean } | null)?.blankDraftRedirect;
  const [sessionKey, setSessionKey] = useState(routeKey);
  if (!isRedirect && sessionKey !== routeKey) setSessionKey(routeKey);
  return isRedirect ? sessionKey : routeKey;
}
